exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".addTaxConfigurationElement{position:relative;padding:1em;margin-bottom:1em;border:solid 1px var(--aluminium-5);border-radius:5px;text-align:center}.addTaxConfigurationElement.full{width:100%}.addTaxConfigurationElement.half{width:48%;align-self:start}.addTaxConfigurationElement .title{font-size:.9rem;font-weight:bold;margin-bottom:.5em}.addTaxConfigurationElement .subtitle{font-size:.8rem;margin-bottom:1em}", ""]);

// exports
